import { comparisonColor, comparisonPositive } from '../../helpers/Custom';
import { Dashboard } from '../../models/ApiModels';
import ColumnChart from './ColumnChart';
interface Props {
  dashboardData: Dashboard;
  compare: boolean;
}
const DashboardDataBoats = (props: Props) => {
  const overviewToMap = [
    {
      label: 'Assigned boat model',
      className: 'prose-heading3',
      data: props.dashboardData.systems.connectedWithBoatModel,
      suffix: '',
    },
    {
      label: 'Assigned boat model',
      className: 'prose-heading3 text-primary-100',
      data: props.dashboardData.systems.connectedWithBoatModelPercentage,
      suffix: '%',
    },
    {
      label: 'Assigned preset',
      className: 'prose-heading3',
      data: props.dashboardData.systems.connectedWithPreset,
      suffix: '',
    },
  ];

  return (
    <div className='flex flex-col w-full flex-1'>
      <div className='prose-heading4 mb-5 mt-10'>Boats</div>
      <div className='bg-gray-3 pt-4 px-4 mb-4 md:mb-0 flex-1 flex flex-col'>
        <div className='text-center mt-4'>System and boat model size</div>
        <div className='flex-1'>
          {props.dashboardData && (
            <ColumnChart
              series={[
                props.dashboardData.boats.lessThanSixMeters,
                props.dashboardData.boats.sixToEightMeters,
                props.dashboardData.boats.eightToTenMeters,
                props.dashboardData.boats.tenToTwelveMeters,
                props.dashboardData.boats.twelveToFourteenMeters,
                props.dashboardData.boats.fourteenToSixteenMeters,
                props.dashboardData.boats.moreThanSixteenMeters,
              ]}
              labels={['<6m', '6-8m', '8-10m', '10-12m', '12-14m', '14-16m', '>16m']}
              compare={props.compare}
            />
          )}
        </div>
        <div className='w-full max-w-3xl mx-auto flex justify-center gap-8 md:gap-16 mt-auto pb-8 px-4'>
          {props.dashboardData &&
            overviewToMap.map((item) => (
              <div key={item.label} className='text-center flex-2 min-w-0'>
                <div>{item.label}</div>
                <h3 className={item.className}>
                  {item.data.count}
                  {item.suffix}
                </h3>
                {props.compare && (
                  <span className={`prose-heading4 ${comparisonColor(item.data.diff)}`}>
                    {comparisonPositive(item.data.diff) + item.data.diff}
                  </span>
                )}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardDataBoats;
